<template>
  <section class="section section-4 green-background">
    <div
      class="container"
      v-for="hrDetail of hrDetails"
      v-bind:key="hrDetail._id"
    >
      <div v-if="hrDetail._id">
        <h2>{{ hrDetail.title }}</h2>
        <div class="row align-items-center">
          <div class="col-md-3">
            <div class="media-container text-xs-center text-sm-center text-md-left">
              <img
                :src="
                  'https://cdn.tavakademi.com/uploads/5ef1b5f29a24df0df44f084c/static-pages/list-images/' +
                    hrDetail.listImage
                "
                alt="hrDetail.title"
              />
              <p v-html="hrDetail.shortDescription"></p>
            </div>
          </div>
          <div class="col-md-9 body text-xs-center text-sm-center text-md-left"><p
            :inner-html.prop="hrDetail.description | truncate(1197)"></p></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ContentService from "@/services/ContentService.js";

export default {
  data() {
    return {
      hrDetails: [],
    };
  },
  created() {
     ContentService.getCategorizedContent(this.$application, this.$t("languageCode"), this.$t("humanResources"))
      .then((res) => (this.hrDetails = res.data))
      .catch((error) => console.log("There was an error:" + error));
  },

  mounted() {},

  filters: {
    truncate: function(text, stop, clamp) {
      return text.slice(0, stop) + (stop < text.length ? clamp || "..." : "");
    },
  },
};
</script>

<style></style>
